import React, { useState } from 'react';
import Breadcrumbs from '../components/BreadCrumbs';
import fullLogo from "../assets/icons/full-logo.png";
import { Form, Formik } from 'formik';
import * as Yup from "yup";
import InputField from '../components/inputFields/InputField';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import FormikDropdown from '../components/inputFields/FormikDropDown';
import { addNewEnquiry } from '../services/clinic/enquiry';
import { getUserName } from '../utils/localStoarege';
import FormikMultiSelectDropdown from '../components/inputFields/FormikMultiSelectDropdown';

function EnquiryForClinic() {

    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState({
        name: "",
        gender: "",
        phone_number: "",
        address: "",
        duration: "",
        activity: "",
        age: null,
        last_treatment: "",
    });

    const validationSchema = Yup.object({
        name: Yup.string().required("Full Name is required"),
        phone_number: Yup.string().required("Phone number is required"),
        gender: Yup.string().required("Gender is required"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            const response = await addNewEnquiry({
                ...values,
                center: getUserName(),
                activity: values?.activity?.length > 0 ? values?.activity?.join(",") : null,
                age: values?.age ?? 0,
            });
            if (response?.status === 201) {
                toast.success("Enquiry added successfully!");
                navigate(-1);
            } else if (response?.status === 400) {
                toast.error(response?.data?.error);
            } else {
                toast.error("Oops! Something went wrong, please try again.");
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        } finally {
            setSubmitting(false);
        }
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/package-invoice' },
            { name: 'Enquiry', link: (-1) },
            { name: 'Add Enquiry' },
        ]} />
        <div className="bg-white shadow-md rounded-lg p-6 max-w-2xl mt-2">
            {/* Header Section */}
            <div className="text-center mb-4">
                <div className="flex flex-row justify-center w-full">
                    <img src={fullLogo} className='max-h-20' alt="HUD-Logo" />
                </div>
                <p className="text-sm text-gray-600">Dr. Sanjay Dubey</p>
                <p className="text-sm text-gray-600">HO. INDORE<br /> Branches Located At:
                    Nagpur, Ahmedabad, Pune, Delhi, Mumbai, Vadodara, Raipur, Surat, Hyderabad, and Bangalore</p>
                <p className="text-sm text-gray-600">E-Mail: info@maharshivitiligo.com</p>
                <p className="text-sm text-gray-600"><a href="https://www.maharshivitiligo.com/" className='underline text-primary'>www.maharshivitiligo.com</a></p>
            </div>

            {/* Receipt Info */}
            <div className="items-center border-t border-b py-2 mb-4">
                <div className="flex justify-between">
                    <p className="text-sm text-gray-600">
                        Dated: {new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "short", year: "numeric" }).format(new Date())}
                    </p>
                </div>
            </div>

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ isSubmitting, setFieldValue, values }) => (
                    <Form className="space-y-4">
                        <InputField
                            label="Full Name"
                            name="name"
                            type="text"
                            placeholder="Enter patient's full name"
                            required
                        />
                        <FormikDropdown
                            label="Gender"
                            name="gender"
                            placeholder="Select Gender"
                            required
                            options={[
                                { label: "Male", value: "Male" },
                                { label: "Female", value: "Female" },
                            ]}
                        />

                        <InputField
                            label="Phone Number"
                            name="phone_number"
                            type="text"
                            placeholder="Enter patient's phone number"
                            required
                        />

                        <InputField
                            label="Age"
                            name="age"
                            type="text"
                            placeholder="Enter patient's age"
                        />

                        <InputField
                            label="Address"
                            name="address"
                            type="text"
                            placeholder="Enter patient's address"
                        />

                        <InputField
                            label="Duration"
                            name="duration"
                            type="text"
                            placeholder="Enter patient's duration"
                        />

                        <FormikMultiSelectDropdown
                            label="Activity"
                            name="activity"
                            needSearch
                            placeholder="Select Activity"
                            options={[
                                { value: "Negative", label: "Negative" },
                                { value: "Positive", label: "Positive" },
                                { value: "Kobe Negative", label: "(Kobe negative)" },
                                { value: "Kobe Positive", label: "(Kobe positive)" },
                                { value: "In relation father & mother", label: "(In relation father & mother)" },
                                { value: "Father", label: "(Father)" },
                                { value: "Mother", label: "(Mother)" },
                                { value: "Sister", label: "(Sister)" },
                                { value: "Positive Father", label: "(Positive father)" },
                                { value: "Positive Mother", label: "(Positive mother)" },
                            ]}
                        />

                        <InputField
                            label="Last Treatment"
                            name="last_treatment"
                            type="text"
                            placeholder="Enter patient's last treatment"
                        />

                        {/* Submit Button */}
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="bg-primary text-white px-4 py-2 rounded-md hover:bg-blue-700"
                            >
                                Submit
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>

            {/* Details Section */}
            <div className="mb-4">
            </div>

            {/* Footer */}
            <div className="mt-10 text-end">
                <p className="font-medium text-gray-700">____________________</p>
                <p className="font-medium text-gray-700">Authorised Signatory</p>
            </div>
        </div>
    </>);
}

export default EnquiryForClinic;